import {ButtonPrimary, ButtonSecondary, Input, ModalBase} from "pac-ux-components";
import React from "react";

const labelStyle = {width: '100%', color: 'black', fontSize: 16, fontWeight: '400', marginBottom: 4, marginTop: 16};
const inputStyle = {background: 'white', borderRadius: 2, border: '1px #949494 solid', width: 530, height: 40, margin: '8px 0px'};
const hintStyle = {fontSize: 12, color: '#5A6B7B', marginTop: -4};

/**
 * Upsert of one exchange rate shipped inside the signed offline policy (PYMNT-2590 design 8.1):
 * {iso, rate, name}, where rate is USD per one unit of iso and travels as a decimal string.
 */
function ForexRateModal({rate, display, handleSave, closeModal}) {
    const [form, setForm] = React.useState({
        iso: rate ? rate.iso : '',
        rate: rate && rate.rate !== null && rate.rate !== undefined ? String(rate.rate) : '',
        name: rate && rate.name ? rate.name : '',
    });
    const [saving, setSaving] = React.useState(false);
    const [message, setMessage] = React.useState(null);

    return (<div>
        <ModalBase style={{display: (display === true) ? 'block' : 'none'}}>
            <form onSubmit={async (e) => {
                e.preventDefault();
                e.stopPropagation();
                setMessage(null);
                if (!/^[A-Z]{3}$/.test(form.iso)) {
                    setMessage('Currency must be a 3-letter ISO 4217 code');
                    return;
                }
                if (!(Number(form.rate) > 0)) {
                    setMessage('Rate must be greater than zero');
                    return;
                }
                setSaving(true);
                const error = await handleSave({
                    iso: form.iso,
                    rate: String(form.rate).trim(),
                    name: form.name.trim() === '' ? null : form.name.trim(),
                });
                setSaving(false);
                if (error) {
                    setMessage(error);
                    return;
                }
                closeModal(true);
            }}>
                <div style={{width: '619px', paddingLeft: 33, paddingBottom: 32, fontFamily: 'Inter'}}>
                    <div style={{width: '100%', color: 'black', fontSize: 24, fontWeight: '700', marginTop: 38}}>
                        {rate ? 'Edit exchange rate' : 'Add exchange rate'}
                    </div>
                    <div style={labelStyle}>Currency (ISO 4217)</div>
                    <Input value={form.iso} maxLength={3} required={true} disabled={!!rate}
                           onChange={(e) => setForm({...form, iso: e.target.value.toUpperCase()})}
                           style={inputStyle}/>
                    <div style={labelStyle}>Rate (USD per one unit)</div>
                    <Input value={form.rate} type="number" step="0.00000001" min="0" required={true}
                           onChange={(e) => setForm({...form, rate: e.target.value})}
                           style={inputStyle}/>
                    <div style={hintStyle}>The aircraft multiplies an amount in this currency by the rate to apply the USD limits.</div>
                    <div style={labelStyle}>Name</div>
                    <Input value={form.name} maxLength={50}
                           onChange={(e) => setForm({...form, name: e.target.value})}
                           style={inputStyle}/>
                    {message && (<div style={{color: '#B00020', marginTop: 16, fontSize: 14}}>{message}</div>)}
                    <div style={{display: 'flex', gap: 12, marginTop: 32}}>
                        <ButtonPrimary type="submit" disabled={saving}>Save</ButtonPrimary>
                        <ButtonSecondary type="button" onClick={() => closeModal(false)}>Cancel</ButtonSecondary>
                    </div>
                </div>
            </form>
        </ModalBase>
    </div>);
}

export default ForexRateModal;
